import { c as _c } from "react/compiler-runtime";
import { Button } from "@navikt/ds-react";
import NextLink from "next/link";
import { publicEnv } from "@/env-variables/publicEnv";
import { UiSelector } from "@/utils/uiSelectors";
export function ExitButton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Button data-testid={UiSelector.ExitButton} as={NextLink} href={publicEnv.NEXT_PUBLIC_MIN_SIDE_ARBEIDSGIVER_URL} variant="secondary">Tilbake til Min side Arbeidsgiver</Button>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}